export enum TransferDirection {
    Left = 'left',
    Right = 'right'
  }